import Vue from 'vue'
import Router from 'vue-router'
import AdminDashboard from '@/views/AdminDashboard.vue'
import AdminEditCircuit from '@/views/AdminEditCircuit.vue'
import AdminEditEquipment from '@/views/AdminEditEquipment.vue'
import AdminEditExercise from '@/views/AdminEditExercise.vue'
import AdminEditRoutine from '@/views/AdminEditRoutine.vue'
import ExerciseFinder from '@/views/ExerciseFinder.vue'
import CircuitFinder from '@/views/CircuitFinder.vue'
import CircuitInfo from '@/views/CircuitInfo.vue'
import CircuitPlayer from '@/views/CircuitPlayer.vue'
import Login from '@/views/Login.vue'
import RoutineFinder from '@/views/RoutineFinder.vue'
import RoutineInfo from '@/views/RoutineInfo.vue'
import RoutinePlayer from '@/views/RoutinePlayer.vue'
import UserAccount from '@/views/UserAccount.vue'
import UserDashboard from '@/views/UserDashboard.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/account',
      name: 'account',
      component: UserAccount,
      props: false
    },
    {
      path: '/',
      name: 'dashboard',
      component: UserDashboard,
      props: false
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminDashboard,
      props: false
    },
    {
      path: '/admin-edit-circuit/:circuitId?',
      name: 'admin-edit-circuit',
      component: AdminEditCircuit,
      props: true
    },
    {
      path: '/admin-edit-equipment/:equipmentId?',
      name: 'admin-edit-equipment',
      component: AdminEditEquipment,
      props: true
    },
    {
      path: '/admin-edit-exercise/:exerciseId?',
      name: 'admin-edit-exercise',
      component: AdminEditExercise,
      props: true
    },
    {
      path: '/admin-edit-routine/:routineId?',
      name: 'admin-edit-routine',
      component: AdminEditRoutine,
      props: true
    },
    {
      path: '/circuit-finder',
      name: 'circuit-finder',
      component: CircuitFinder,
      props: false
    },
    {
      path: '/circuit-info/:circuitId',
      name: 'circuit-info',
      component: CircuitInfo,
      props: true
    },
    {
      path: '/circuit-player/:circuitId',
      name: 'circuit-player',
      component: CircuitPlayer,
      props: true
    },
    {
      path: '/exercise-finder',
      name: 'exercise-finder',
      component: ExerciseFinder,
      props: false
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: false
    },
    {
      path: '/routine-finder',
      name: 'routine-finder',
      component: RoutineFinder,
      props: false
    },
    {
      path: '/routine-info/:routineId',
      name: 'routine-info',
      component: RoutineInfo,
      props: true
    },
    {
      path: '/routine-player/:routineId',
      name: 'routine-player',
      component: RoutinePlayer,
      props: true
    }
  ]
})
